module.exports = __webpack_public_path__ + "img/android.33535b79.png";